<mat-form-field class="w-100" [tcTooltip]="tooltipText" [placement]="tooltipPlacement">
    <mat-label>
        {{ name }}
    </mat-label>
    <mat-select
        [(ngModel)]="value"
        (ngModelChange)="_onChangeCallback($event)"
        (blur)="_onTouchedCallback()"
        [required]="isRequired"
        [disabled]="isDisabled"
        #control="ngModel"
    >
        <mat-option
            *ngFor="let item of listBoxValues | selectSort: 'asc':'position'"
            [value]="item.value"
            [style.color]="item.color"
        >
            <mat-icon *ngIf="item.icon" fontSet="plentyicons" [fontIcon]="item.icon"></mat-icon>
            {{ item.caption }}
        </mat-option>
    </mat-select>
    <mat-error *ngIf="control.hasError('required')">
        {{ 'validators.required' | translate: _locale.language }}
    </mat-error>
</mat-form-field>
